import { createContext, useContext, type ReactNode } from 'react'
import { useDashboardPropertyOptions, type TDashboardPropertyOptions } from './useDashboardPropertyOptions'

const DashboardFiltersContext = createContext<TDashboardPropertyOptions | null>(null)

export const DashboardFiltersProvider = ({ children }: { children: ReactNode }) => {
  const filters = useDashboardPropertyOptions()

  return <DashboardFiltersContext.Provider value={filters}>{children}</DashboardFiltersContext.Provider>
}

export const useDashboardFilters = (): TDashboardPropertyOptions => {
  const ctx = useContext(DashboardFiltersContext)

  if (!ctx) {
    throw new Error('useDashboardFilters must be used inside a DashboardFiltersProvider')
  }

  return ctx
}
